import { ApplicationFormAnswers, FeatureSwitches } from '../components/ApplicationForm/ApplicationFormContext'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapAnswers = (answers: Record<string, any>, featureSwitches: FeatureSwitches): ApplicationFormAnswers => ({
  addressHistory: { ...answers.addressHistory },
  drivingLicence: answers.drivingLicence,
  employmentHistory: { ...answers.employmentHistory },
  loanAmount: answers.loanAmount,
  maritalStatus: answers.maritalStatus,
  monthlyIncome: answers.monthlyIncome,
  personalDetails: {
    dateOfBirth: answers.dateOfBirth,
    title: answers.personalDetails.title,
    firstName: answers.personalDetails.firstName,
    surname: answers.personalDetails.surname,
    emailAddress: (featureSwitches.personalDetailsV4_2)
      ? answers.contactInfo.emailAddress : answers.personalDetails.emailAddress,
    contactNumber: mapContactInfo(answers, featureSwitches)
  },
  vehicleType: answers.vehicleType,
  vehicleRegistration: answers.vehicleRegistration
})

const mapContactInfo = (answers: Record<string, any>, featureSwitches: FeatureSwitches) => {
  if (featureSwitches.personalDetailsV4_2) return answers.contactInfo.contactNumber
  return answers.personalDetails.contactNumber
}

